export const setDisplayOnElement = (element, displayPropertyValue) => {
  element.style.display = displayPropertyValue;
};

export const isMobileBrowserWidth = () => {
  return window.innerWidth <= 575;
};
